<div
  [ngClass]="{'phantom-block': hasPaddingTop && isMobile, 'phantom-block-desktop': hasPaddingTop && !isMobile}"
  id="phantom-view-{{view?.id}}-{{viewType}}"
></div>
